import { render, staticRenderFns } from "./recommendProducts.vue?vue&type=template&id=8535f490&scoped=true"
import script from "./recommendProducts.vue?vue&type=script&lang=js"
export * from "./recommendProducts.vue?vue&type=script&lang=js"
import style0 from "./recommendProducts.vue?vue&type=style&index=0&id=8535f490&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8535f490",
  null
  
)

export default component.exports